<template>
    <v-form :disabled="isEditableForm">
        <v-dialog
            transition="dialog-top-transition"
            max-width="1200"
            v-model="isOpenDialog"
            persistent
        >
            <v-card class="pa-4">
                <v-card-title primary-title>
                    <v-row dense justify="space-between">
                        <v-col cols="12" sm="8">
                            <div
                                v-if="$vuetify.breakpoint.mdAndDown"
                                :class="`primary--text text-overline ml-2 ${
                                    $vuetify.breakpoint.xs ? 'text-center' : ''
                                }`"
                            >
                                Promoción
                            </div>
                            <div
                                v-else
                                class="
                                    font-weight-light
                                    primary--text
                                    text-h4
                                    ml-2
                                    text-capitalize
                                "
                            >
                                Promoción
                            </div>
                        </v-col>
                        <v-col
                            sm="4"
                            cols="12"
                            :class="`d-flex align-center ${
                                $vuetify.breakpoint.smAndDown
                                    ? 'justify-center font-weight-light'
                                    : 'justify-end'
                            }`"
                        >
                            <v-switch
                                v-model="IsActive"
                                inset
                                color="green"
                                :label="IsActive ? 'Activa' : 'Inactiva'"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-row no-gutters>
                    <v-col md="6" cols="12" class="pr-1">
                        <v-card outlined class="px-4">
                            <v-row>
                                <v-col md="12" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Datos Básicos
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mb-n7">
                                <v-col md="6" cols="12">
                                    <v-text-field
                                        v-model="Name"
                                        label="Nombre"
                                        style="padding: 21.1px 0px 17px 0px"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="6" cols="12">
                                    <v-select
                                        clearable
                                        chips
                                        :items="opciones.tarifas.operator"
                                        item-text="human"
                                        item-value="encoded"
                                        v-model="Operator"
                                        :label="
                                            Operator ? Operator : 'Operador'
                                        "
                                    >
                                        <template #selection="{ item }">
                                            <v-chip
                                                :color="
                                                    isEditableForm
                                                        ? 'primary lighten-3'
                                                        : 'primary'
                                                "
                                                class="white--text"
                                            >
                                                <v-icon>
                                                    mdi-signal-variant
                                                </v-icon>
                                                {{ item.human }}
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <!--Desktop view duracion y cuantia-->
                    <v-col v-if="!$vuetify.breakpoint.smAndDown" md="6">
                        <v-card outlined class="px-4 pb-1">
                            <v-row>
                                <v-col md="6" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Duración
                                    </h4>
                                </v-col>
                                <v-col md="6" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Cuantía
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mb-n7">
                                <v-col md="3">
                                    <v-text-field
                                        v-model="Duration"
                                        label="Tiempo"
                                        required
                                        style="padding: 21.1px 0px 12px 0px"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    md="3"
                                    style="padding: 21px 10px 0px 10px"
                                >
                                    <v-select
                                        hide-selected
                                        :items="['day', 'month', 'year']"
                                        label="Unidad"
                                        v-model="Duration_Unit"
                                    ></v-select>
                                </v-col>
                                <v-col md="2">
                                    <v-text-field
                                        v-model="Amount"
                                        label="Valor"
                                        required
                                        style="padding: 21.1px 0px 12px 0px"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    md="4"
                                    style="padding: 21px 10px 0px 10px"
                                >
                                    <v-select
                                        hide-selected
                                        :items="['MONETARY', 'PERCENTS']"
                                        label="Unidad"
                                        v-model="Amount_Unit"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <!--Mobile view duracion y cuantia-->
                    <v-col
                        v-if="$vuetify.breakpoint.smAndDown"
                        cols="12"
                        class="mt-2"
                    >
                        <v-card outlined class="px-4 pb-1">
                            <v-row>
                                <v-col cols="12" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Duración
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="Duration"
                                        label="Tiempo"
                                        required
                                        style="padding: 21.1px 0px 12px 0px"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="6"
                                    style="padding: 21px 10px 0px 10px"
                                >
                                    <v-select
                                        hide-selected
                                        :items="['day', 'month', 'year']"
                                        label="Unidad"
                                        v-model="Duration_Unit"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card outlined class="px-4 pb-1 mt-2">
                            <v-row class>
                                <v-col md="6" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Cuantía
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mb-n7">
                                <v-col md="2">
                                    <v-text-field
                                        v-model="Amount"
                                        label="Valor"
                                        required
                                        style="padding: 21.1px 0px 12px 0px"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    md="4"
                                    style="padding: 21px 10px 0px 10px"
                                >
                                    <v-select
                                        hide-selected
                                        :items="['MONETARY', 'PERCENTS']"
                                        label="Unidad"
                                        v-model="Amount_Unit"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row style="margin-top: 6px" no-gutters>
                    <v-col md="12" cols="12">
                        <v-card outlined class="px-4">
                            <v-row>
                                <v-col md="9" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Tarifas/Adicionales/SVA Aplicadas
                                    </h4>
                                </v-col>
                                <v-col md="3" class="mb-1 mt-1">
                                    <h4 class="font-weight-light primary--text">
                                        Seleccionar Todos
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mb-n3">
                                <v-col md="9" cols="12">
                                    <v-autocomplete
                                        clearable
                                        multiple
                                        dense
                                        chips
                                        :items="availableTariffsDropDown"
                                        persistent-hint
                                        :hint="
                                            availableTariffsDropDown.length.toString() +
                                            ' disponibles'
                                        "
                                        item-text="name"
                                        item-value="id"
                                        :no-data-text="
                                            tariffsDropDown.length == 0
                                                ? 'No hay tarifas disponibles'
                                                : 'Selecciona un operador primero'
                                        "
                                        v-model="SelectedTariffs"
                                        label="Tarifas"
                                    >
                                        <template #selection="{ item }">
                                            <v-chip
                                                outlined
                                                @click:close="remove(item)"
                                                close
                                                :color="
                                                    isEditableForm
                                                        ? 'pink lighten-3'
                                                        : 'pink'
                                                "
                                                class="mt-1 white--text"
                                            >
                                                <v-icon>
                                                    mdi-credit-card
                                                </v-icon>
                                                {{
                                                    item.name
                                                        ? item.name
                                                        : item.id
                                                }}
                                            </v-chip>
                                        </template>
                                        <template #item="{ item }">
                                            <v-row>
                                                <v-col cols="6">
                                                    {{
                                                        item && item.name
                                                            ? item.name
                                                            : item.id
                                                    }}
                                                </v-col>
                                                <v-col cols="1">
                                                    {{ item.type }}
                                                </v-col>
                                                <v-col cols="2">
                                                    {{ item.segment }}
                                                </v-col>
                                                <v-col cols="2">
                                                    {{ item.operator }}
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-icon
                                                        :color="
                                                            item.is_active
                                                                ? 'green'
                                                                : 'red'
                                                        "
                                                    >
                                                        mdi-circle
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col
                                    class="
                                        d-flex
                                        flex-column
                                        justify-center
                                        py-6
                                    "
                                    md="1"
                                    @click="changeAllTariffs"
                                >
                                    <h3 class="overline d-flex justify-center">
                                        Tarifas
                                    </h3>
                                    <v-icon
                                        :color="allTariffs ? 'success' : 'red'"
                                    >
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                                <v-col
                                    class="d-flex flex-column justify-center"
                                    md="1"
                                    @click="changeAllAditional"
                                >
                                    <h3 class="overline d-flex justify-center">
                                        Adicionales
                                    </h3>
                                    <v-icon
                                        :color="
                                            allAditional ? 'success' : 'red'
                                        "
                                    >
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                                <v-col
                                    class="d-flex flex-column justify-center"
                                    md="1"
                                    @click="changeAllSVA"
                                >
                                    <h3 class="overline d-flex justify-center">
                                        SVA
                                    </h3>
                                    <v-icon :color="allSVA ? 'success' : 'red'">
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-card-actions class="justify-end">
                    <v-btn
                        depressed
                        color="primary"
                        @click="submitPromotion"
                        v-if="!isEditableForm"
                    >
                        Guardar
                    </v-btn>
                    <v-btn text color="red" @click="closeForm"> Cerrar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'PromotionManagementForm',
    data: () => ({
        allTariffs: false,
        allAditional: false,
        allSVA: false,
    }),
    methods: {
        changeAllTariffs() {
            this.allTariffs = !this.allTariffs;
            this.allAditional = false;
            this.allSVA = false;

            let allTariffsFilter = (item) =>
                this.allTariffs ? item.type == 'TARIFF' : false;
            let filtered = this.availableTariffsDropDown.filter((item) =>
                allTariffsFilter(item)
            );

            this.SelectedTariffs = [];
            filtered.forEach((element) =>
                this.SelectedTariffs.push(element.id)
            );
        },
        changeAllAditional() {
            this.allAditional = !this.allAditional;
            this.allTariffs = false;
            this.allSVA = false;

            let allAditionalFilter = (item) =>
                this.allAditional ? item.type == 'ADITIONAL' : false;
            let filtered = this.availableTariffsDropDown.filter((item) =>
                allAditionalFilter(item)
            );

            this.SelectedTariffs = [];
            filtered.forEach((element) =>
                this.SelectedTariffs.push(element.id)
            );
        },
        changeAllSVA() {
            this.allSVA = !this.allSVA;
            this.allAditional = false;
            this.allTariffs = false;

            let allSVAFilter = (item) =>
                this.allSVA ? item.type == 'SVA' : false;
            let filtered = this.availableTariffsDropDown.filter((item) =>
                allSVAFilter(item)
            );

            this.SelectedTariffs = [];
            filtered.forEach((element) =>
                this.SelectedTariffs.push(element.id)
            );
        },
        remove(item) {
            let index = this.SelectedTariffs.indexOf(item.id);
            this.SelectedTariffs.splice(index, 1);
        },
        clearFields() {
            this.$store.state.ManagementBase.promotionManagement.Name = '';
            this.$store.state.ManagementBase.promotionManagement.Operator = '';
            this.$store.state.ManagementBase.promotionManagement.Duration = '';
            this.$store.state.ManagementBase.promotionManagement.Duration_Unit =
                '';
            this.$store.state.ManagementBase.promotionManagement.Amount = '';
            this.$store.state.ManagementBase.promotionManagement.Amount_Unit =
                '';
            this.$store.state.ManagementBase.promotionManagement.IsActive = false;
            this.$store.state.ManagementBase.promotionManagement.SelectedTariffs =
                [];
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/promotionManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitPromotion() {
            if (
                this.$store.state.ManagementBase.promotionManagement.formType ==
                'add'
            )
                this.$store.dispatch(
                    'ManagementBase/promotionManagement/addPromotion'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/promotionManagement/editPromotion'
                );

            this.closeForm();
        },
    },
    computed: {
        availableTariffsDropDown() {
            return this.tariffsDropDown.filter(
                (item) =>
                    item.operator == this.Operator && item.is_active == true
            );
        },
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Name',
                    val
                );
            },
        },
        Duration: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Duration;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Duration',
                    val
                );
            },
        },
        Duration_Unit: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Duration_Unit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Duration_Unit',
                    val
                );
            },
        },
        Amount: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Amount;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Amount',
                    val
                );
            },
        },
        Amount_Unit: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Amount_Unit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Amount_Unit',
                    val
                );
            },
        },
        Operator: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .Operator;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/Operator',
                    val
                );
            },
        },
        SelectedTariffs: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .SelectedTariffs;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/SelectedTariffs',
                    val
                );
            },
        },
        IsActive: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/IsActive',
                    val
                );
            },
        },
        isEditableForm: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .isEditableForm;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/isEditableForm',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase/promotionManagement', {
            tariffsDropDown: (state) => state.tariffsDropDown,
        }),
    },
    watch: {
        Operator() {
            this.allTariffs = false;
            this.allAditional = false;
            this.allSVA = false;
        },
    },
};
</script>
